// @flow
import MenuItemDish from './MenuItemDish';

export default MenuItemDish;
